import { takeLatest, all } from "redux-saga/effects";

//handlers
import { handleGetVinFromImage } from "./handlers/vinImage";
import { handleCreateUserCar, handleGetActiveRequests, handleGetCars, handleGetPartOffers, handleGetSingleRequest, handleGetUnActiveRequests } from "./handlers/userCars";
import { getVinFromImage } from "../entities/vinImage";
import { getCars, getCar, getActiveRequests, getUnActiveRequests, getSingleRequest, getPartOffers, createUserCar } from "../entities/userCars";
import { handleGetCar } from "./handlers/userCars";
import { getMaintenanceConfig, getSettingsConfig } from '../entities/configs';
import { handleGetMaintenanceConfig, handleGetSettingsConfig } from './handlers/configs';
import { handleGetGenerationsCar, handleGetMakesCar, handleGetModelsCar, handleGetMotorsCar } from "./handlers/cars";
import { getGenerationsCar, getMakesCar, getModelsCar, getMotorsCar } from "../entities/cars";
import { getUserFilterCount } from "../entities/userFilter";
import { handleGetUserFilterCount } from "./handlers/userFilter";
import { getAllActiveRequests, getPartRequestCount, createRequest } from "../entities/partRequest";
import { handleCreateRequest, handleGetAllActiveRequests, handleGetPartRequestCount } from "./handlers/partRequest";
import { getNewNotifications, getOldNotifications } from "../entities/notifications";
import { handleGetUserNewNotifications, handleGetUserOldNotifications } from "./handlers/notifications";
import { getActiveRequestsMessages, getOtherMessages, getPartOfferMessages, sendMessage } from "../entities/messages";
import { handleGetPartOfferMessages, handleGetUserActiveRequestsMessages, handleGetUserOtherMessages, handleSendMessage } from "./handlers/messages";
import { getPartOffer } from "../entities/partOffers";
import { handleGetPartOffer } from "./handlers/partOffers";
import { createAddress, getAddresses } from "../entities/address";
import { handleCreateAddress, handleGetAddresses } from "./handlers/address";

export function* watcherSaga() {
    yield all([
        takeLatest(getVinFromImage.type, handleGetVinFromImage),
        takeLatest(getCars.type, handleGetCars),
        takeLatest(getCar.type, handleGetCar),
        takeLatest(getActiveRequests.type, handleGetActiveRequests),
        takeLatest(getUnActiveRequests.type, handleGetUnActiveRequests),
        takeLatest(getMaintenanceConfig.type, handleGetMaintenanceConfig),
        takeLatest(getSettingsConfig.type, handleGetSettingsConfig),
        takeLatest(getSingleRequest.type, handleGetSingleRequest),
        takeLatest(getPartOffers.type, handleGetPartOffers),
        takeLatest(getMakesCar.type, handleGetMakesCar),
        takeLatest(getModelsCar.type, handleGetModelsCar),
        takeLatest(getGenerationsCar.type, handleGetGenerationsCar),
        takeLatest(getMotorsCar.type, handleGetMotorsCar),
        takeLatest(getUserFilterCount.type, handleGetUserFilterCount),
        takeLatest(getPartRequestCount.type, handleGetPartRequestCount),
        takeLatest(getAllActiveRequests.type, handleGetAllActiveRequests),
        takeLatest(getNewNotifications.type, handleGetUserNewNotifications),
        takeLatest(getOldNotifications.type, handleGetUserOldNotifications),
        takeLatest(getActiveRequestsMessages.type, handleGetUserActiveRequestsMessages),
        takeLatest(getOtherMessages.type, handleGetUserOtherMessages),
        takeLatest(getPartOffer.type, handleGetPartOffer),
        takeLatest(getPartOfferMessages.type, handleGetPartOfferMessages),
        takeLatest(sendMessage.type, handleSendMessage),
        takeLatest(getAddresses, handleGetAddresses),
        takeLatest(createRequest.type, handleCreateRequest),
        takeLatest(createUserCar.type, handleCreateUserCar),
        takeLatest(createAddress.type, handleCreateAddress)
    ]);
}
